class adjustInvoiceCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, $timeout) {
        $scope.baseInfo = { ...items1 }
        $scope.invoiceTableList = items1.invoiceDetail || []
        let invoiceIdList = $scope.invoiceTableList.reduce((total, curr) => {
            curr.$isSelected = true
            total.push(curr.invoiceId)
            return total
        }, [])
        const baseParams = {
            invoiceNumber: '',
            invoiceDate: '',
            adValoremTotal: '',
            totalTaxamt: '',
            saleName: '',
        }
        $scope.pageOpt2 = {
            totalItems: 0, // 组件初始化设置总页数
            currentPage: 1, // 设置显示第一页
            maxSize: 0, // 每一页显示记录数
        }
        $scope.isFinding = false
        $scope.isConsistent = false
        // 页码数
        $scope.paginationIsShow = true

        const handleChange = (function (_this){
            let timer
            return function(fn){
                if (timer) {
                    clearTimeout(timer)
                }
                timer = setTimeout(() => {
                    timer = null
                    fn.apply(_this)
                }, 600);
            }
        })()

        // 发票查询
        $scope.invoiceListSearch = (index) => {
            $scope.isFinding = true
            const req = {
                pageNum: $scope.pageOpt2.currentPage,
                pageSize: 5,
                param: Object.assign($scope.invoiceTableList[index], { invoiceIdList }),
            }

            httpRequest.post_qryInvoiceList(req).then((res) => {
                if (res.data.success) {
                    $scope.invoiceFinderList = res.data.value.list.slice()
                    $scope.pageOpt2.totalItems = res.data.value.total
                    $scope.pageOpt2.maxSize = res.data.value.pageSize
                }
            }).finally(() => {
                $scope.isFinding = false
            })
        }

        $scope.invoiceFinderItemClick = (item, item1) => {
            item = Object.assign(item, item1)
            item.$isSelected = true
            if (invoiceIdList.indexOf(item1.invoiceId) === -1) {
                invoiceIdList.push(item1.invoiceId)
            }
            item.invoiceFinderIsShow = false

            let totalTaxamtTmp = $scope.invoiceTableList.reduce((total, item)=>{
                return +item.totalTaxamt + total
            },0)
            $scope.isConsistent = (totalTaxamtTmp === +$scope.baseInfo.creditAmt) && (+$scope.baseInfo.creditAmt !== 0) || (totalTaxamtTmp === +$scope.baseInfo.debitAmt) && (+$scope.baseInfo.debitAmt !== 0)
        }

        $scope.cancel = () => {
            $uibModalInstance.dismiss()
        }
        $scope.ok = () => {
            const invoiceNumberList = $scope.invoiceTableList.reduce((total, curr) => {
                if (curr.invoiceNumber) {
                    total.push(curr.invoiceNumber)
                }
                return total
            }, [])
            if ($scope.invoiceTableList.length !== invoiceNumberList.length) {
                logger.logError('关联发票不允许存在没有发票号码的发票')
                return false
            }
            if (Array.from(new Set(invoiceNumberList)).length !== invoiceNumberList.length) {
                logger.logError('关联发票不允许存在多张相同的发票号码的发票')
                return false
            }
            const ivatVoucherAccountQryDTOList = $scope.invoiceTableList.reduce((total, curr) => {
                const {
                    invoiceNumber, invoiceDate, adValoremTotal, totalTaxamt, saleName,
                } = curr
                total.push({
                    invoiceNumber,
                    invoiceDate,
                    adValoremTotal,
                    totalTaxamt,
                    saleName,
                })
                return total
            }, [])
            const layer = window.layer.msg('发票调整中，请耐心等待', {
                time: 0, skin: 'layer-loading-self', icon: 16, shade: 0.5,
            })
            httpRequest.post_relationInvoice({
                voucherCode: items1.voucherCode,
                ivatVoucherAccountQryDTOList,
            }).then(() => {
                $uibModalInstance.close()
            }).finally(() => {
                window.layer.close(layer)
            })
        }
        function hidePagination() {
            $scope.invoiceTableList.forEach(item=>{
                if(item.invoiceFinderIsShow){
                    delete item.invoiceFinderIsShow
                }
            })
        }
        $scope.addBtn = () => {
            $scope.invoiceTableList.push({ ...baseParams })
        }
        $scope.subBtn = (index) => {
            if ($scope.invoiceTableList[index].invoiceId) {
                invoiceIdList.splice(invoiceIdList.indexOf($scope.invoiceTableList[index].invoiceId), 1)
            }
            $scope.invoiceTableList.splice(index, 1)
        }

        $scope.handleChange = (item, index, iptType) => {
            if (item.adValoremTotal && !(Object.prototype.toString.call(+item.adValoremTotal) === '[object Number]' && !isNaN(+item.adValoremTotal)) && item.adValoremTotal !== '-') {
                logger.logError('价税合计、税额必须为数字，请修改')
                return false
            }

            if (item.totalTaxamt && !(Object.prototype.toString.call(+item.totalTaxamt) === '[object Number]' && !isNaN(+item.totalTaxamt)) && item.totalTaxamt !== '-') {
                logger.logError('价税合计、税额必须为数字，请修改')
                return false
            }

            if (item.adValoremTotal === '-' || item.totalTaxamt === '-') {
                return false
            }
            item.invoiceFinderIsShow = true
            if (item.$isSelected) {
                delete item.$isSelected
            }
            if (item.invoiceId) {
                invoiceIdList.splice(invoiceIdList.indexOf(item.invoiceId), 1)
            }

            if (iptType === 'totalTaxamt') {
                let totalTaxamtTmp = $scope.invoiceTableList.reduce((total, item1) => {
                    return +item1.totalTaxamt + total
                }, 0)
                $scope.isConsistent = (totalTaxamtTmp === +$scope.baseInfo.creditAmt) && (+$scope.baseInfo.creditAmt !== 0) || (totalTaxamtTmp === +$scope.baseInfo.debitAmt) && (+$scope.baseInfo.debitAmt !== 0)
            }
            handleChange(() => {
                $scope.invoiceListSearch(index)
            })
        }
        $scope.handleClick = (item, index, $event) => {
            if (item.adValoremTotal && !(Object.prototype.toString.call(+item.adValoremTotal) === '[object Number]' && !isNaN(+item.adValoremTotal)) && item.adValoremTotal !== '-') {
                logger.logError('价税合计、税额必须为数字，请修改')
                return false
            }

            if (item.totalTaxamt && !(Object.prototype.toString.call(+item.totalTaxamt) === '[object Number]' && !isNaN(+item.totalTaxamt)) && item.totalTaxamt !== '-') {
                logger.logError('价税合计、税额必须为数字，请修改')
                return false
            }

            if (item.adValoremTotal === '-' || item.totalTaxamt === '-') {
                return false
            }
            hidePagination()
            $scope.paginationIsShow = true
            if (item.$isSelected) {
                $scope.invoiceFinderList = [{ ...item }]
                $scope.paginationIsShow = false
            }
            if (!item.$isSelected) {
                $scope.invoiceFinderList = []
                handleChange(() => {
                    $scope.pageOpt2.currentPage = 1
                    $scope.invoiceListSearch(index)
                })
            }
            item.invoiceFinderIsShow = true
            $event.stopPropagation()
        }
        $scope.invoiceFinderClick = ($event) => {
            $event.stopPropagation()
        }
        $timeout(() => {
            document.querySelector('.modal-reconciliation-account-adjust-invoice').addEventListener('click', () => {
                hidePagination()
                $scope.$apply()
            })
        })
    }
}

adjustInvoiceCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', '$timeout']
export default adjustInvoiceCtrl



// WEBPACK FOOTER //
// ./src/app/input/financialCounting/reconciliationAccount/adjustInvoiceCtrl.js